import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { HelmetProvider } from 'react-helmet-async'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import './App.css'

import Header from './Corecomponent/Header'
import EmailHero from './Corecomponent/Emailhero'
import Brandinghero from './Corecomponent/Brandinghero'
import PartnershipScroller from './Corecomponent/PartnershipScroller'
import FeaturesHero from './Corecomponent/Featurehero'
import Serviceproshero from './Corecomponent/Serviceproshero'
import Investorhero from './Corecomponent/Investorhero'
import Makemoneyhero from './Corecomponent/Makemoneyhero'
import Footer2 from './Corecomponent/Footer2'
import Contact from './Corecomponent/contact'
import PrivacyPolicy from './Corecomponent/Pages/privacy-policy'
import TermsConditions from './Corecomponent/Pages/terms-conditions'

function HomePage() {
  const helmetContext = {}

  return (
    <div className="App">
      <HelmetProvider context={helmetContext}>
        <Helmet>
          <title>Redi Platforms</title>
          <meta name="description" content="Redi Platforms" />
          <meta property="og:image" content="%PUBLIC_URL%/Redilogo.png" />
        </Helmet>
        <Header />
        <Brandinghero />
        <EmailHero />
        <PartnershipScroller />
        <FeaturesHero />
        <Serviceproshero />
        <Investorhero />
        <Makemoneyhero />
        <Footer2 />
      </HelmetProvider>
    </div>
  )
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Contact />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsConditions />} />
            <Route path="/Proptech" element={<HomePage />} />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  )
}

export default App
